import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiHeaderMenuComponent} from '@ui/modules/header/ui-header-menu/ui-header-menu.component';
import {RouterModule} from '@angular/router';
import { TooltipModule } from '@ui/modules/tooltip/tooltip.module';
import {
  LucideAngularModule,
  BookOpen,
  Users,
  GraduationCap,
  CalendarDays,
  Wallet,
  Link,
} from 'lucide-angular';

@NgModule({
  declarations: [
    UiHeaderMenuComponent
  ],
  exports: [
    UiHeaderMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
    LucideAngularModule.pick({
      BookOpen,
      Users,
      GraduationCap,
      CalendarDays,
      Wallet,
      Link,
    }),
  ]
})
export class UiHeaderMenuModule {
}
